import { render, staticRenderFns } from "./RestrictUsersDialog.vue?vue&type=template&id=0aeaaf7e"
import script from "./RestrictUsersDialog.vue?vue&type=script&lang=ts"
export * from "./RestrictUsersDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports